// Applies a community's chosen font (from Other Settings) to the whole UI.
// Safe to call repeatedly: each Google Font is injected at most once, and the
// active family is mirrored onto <body> plus a --community-font CSS variable so
// Tailwind/inline styles can opt in via var(--community-font).
const loaded = new Set();

export default function applyCommunityFont(font) {
  const family = String(font || "").trim();
  if (!family) return;

  const id = `community-font-${family.replace(/\s+/g, "-").toLowerCase()}`;
  if (!loaded.has(family) && !document.getElementById(id)) {
    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(
      family
    )}:wght@300;400;500;600;700&display=swap`;
    document.head.appendChild(link);
    loaded.add(family);
  }

  const stack = `'${family}', system-ui, -apple-system, "Segoe UI", Roboto, sans-serif`;
  document.documentElement.style.setProperty("--community-font", stack);
  document.body.style.fontFamily = stack;
}

// Applies the community's text direction (RTL when enabled) to the whole
// front-end membership. Backend/admin is unaffected — this only runs in the FE.
export function applyCommunityDirection(rtl) {
  const dir = Number(rtl) === 1 ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", dir);
  document.body.setAttribute("dir", dir);
}
